import React from 'react';
import PropTypes from 'prop-types';

import FetchControllersWrapper from '@components/common/fetch_controllers_wrapper';
import Web2PrintModal from './web_2_print_modal';

export default class MenuButton extends React.Component {
  state = {
    showModal: false,
  }

  resetShowModal = () => {
    this.setState({ showModal: false });
  }

  renderModal = () => (
    <FetchControllersWrapper>
      <Web2PrintModal
        assetKey={this.props.assetKey}
        resetShowModal={this.resetShowModal}
        imageUrls={this.props.imageUrls}
        pdfUrl={this.props.pdfUrl}
      />
    </FetchControllersWrapper>
  )

  handleShowModal = () => {
    if (this.props.launchedFromModal) {
      BF.fx.dispatchWindowEvent('launchWebToPrint', null, { assetKey: this.props.assetKey });
    } else {
      this.setState((prevState) => ({ showModal: !prevState.showModal }));
    }
  }

  render() {
    const { showModal } = this.state;
    const { launchedFromModal } = this.props;

    return (
      <React.Fragment>
        <button
          className={`select-button ${launchedFromModal ? 'button secondary' : ''}`}
          onClick={this.handleShowModal}
          type="button"
        >
          <div className="s-bulk-select-action">
            <div className="s-bulk-selection-bubble">
              <span className="bff-print icon" />
            </div>
            <div className="s-bulk-select-label hidden-sm hidden-xs">
              {launchedFromModal ? '' : t('Send Print Request')}
            </div>
          </div>
        </button>
        {showModal ? this.renderModal() : null}
      </React.Fragment>
    );
  }
}

MenuButton.propTypes = {
  assetKey: PropTypes.string.isRequired,
  imageUrls: PropTypes.arrayOf(PropTypes.string),
  launchedFromModal: PropTypes.bool,
  pdfUrl: PropTypes.string,
};

MenuButton.defaultProps = {
  imageUrls: null,
  launchedFromModal: false,
  pdfUrl: null,
};
